export const RESUMO = "Resumo";
export const OPERACAO = "Operação";
export const CADASTRO = "Cadastro";
export const RELACIONAMENTO = "Relacionamento";
export const GARANTIA = "Garantia";
export const ANALISE_CREDITO = "Análise de Crédito";
